import React from 'react'
// libs
import styled from 'styled-components'
import { isDesktop } from 'react-device-detect'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE, PopoverModal } from 'components/UI'
import RiskFunction from './components/Function'
// hooks
import { useRiskPermissions } from 'hooks/risks'
// static
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// themes
import colors from 'themes/colors'
// context
import { RiskAPIContext } from 'containers/Risks/Risk/Edit/layers/API'
import { RiskTransactionsContext } from 'containers/Risks/Risk/Edit/layers/RiskTransactions'
// utils
import { size } from 'polished'

const DotsIcon = styled(DotsIconOrigin)`
  && {
    order: 1;
    cursor: pointer;
    min-width: 24px;
    ${size('24px')};

    path {
      fill: ${colors.white};
    }
  }
`

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const RiskFunctions: React.FC = () => {
  const { risk } = React.useContext(RiskAPIContext)
  const { spFunctions, onProcessFnClick } = React.useContext(RiskTransactionsContext)

  const [shouldShow, setShouldShow] = React.useState(false)

  const permissions = useRiskPermissions(risk)

  const disabled = !permissions.riskCreate && !permissions.riskModify && !risk.canUpdateFromSystemProcesses

  React.useEffect(() => {
    setTimeout(() => setShouldShow(true), 3000)
  }, [])

  if (!shouldShow) {
    return <Button isLoading disabled={disabled} style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE}></Button>
  }

  if (!isDesktop && spFunctions.length) {
    const [firstFn, ...functions] = spFunctions

    return (
      <>
        <RiskFunction name={firstFn.name} handleClick={onProcessFnClick(firstFn.name)} disabled={disabled} />
        {spFunctions.length > 1 && (
          <PopoverModal trigger={<DotsIcon />}>
            {({ closePopup }) => (
              <MenuContainer>
                {functions.map((item) => (
                  <RiskFunction
                    isMobile
                    key={item.name}
                    name={item.name}
                    disabled={disabled}
                    handleClick={onProcessFnClick(item.name, closePopup)}
                  />
                ))}
              </MenuContainer>
            )}
          </PopoverModal>
        )}
      </>
    )
  }

  return (
    <>
      {spFunctions.map((item) => (
        <RiskFunction key={item.name} name={item.name} handleClick={onProcessFnClick(item.name)} disabled={disabled} />
      ))}
    </>
  )
}

export default RiskFunctions
